import axios from "axios";
import { useNavigate } from "react-router-dom";
import { authHeader } from "../../utils/helperFunction";



const PlacementApi =  {
    getProgressService : () => {
        return axios({
            method:'get',
            url:'https://placementportalwebservices.herokuapp.com/api/user/progress',
            headers : authHeader()
        }).then(res => res.data).catch((e) => {
            if(e.response.status === 403){
                window.location.href  = "/login"
            }
           
            return Promise.reject(e)
        })
    },
    getEventsList: (type:string) => {
        return axios({
            method:'get',
            url:"https://placementportalwebservices.herokuapp.com/api/user/getEvents",
            headers : authHeader(),
            params: {
                type: type,
              },
        }).then(res => {
            return res.data
        }).catch((e) => {
            if(e.response.status === 403){
                window.location.href  = "/login"
            }
            return Promise.reject(e)
        })  
    },
    getPlacementDetails : () => {
        return axios({
            method:'get',
            url:'https://placementportalwebservices.herokuapp.com/api/user/getPlacements',
            headers : authHeader()
        }).then(res => res.data).catch((e) => {
            if(e.response.status === 403){
                window.location.href  = "/login"
            }
            return Promise.reject(e)
        })
    },
    getAttendanceDetails : () => {
        return axios({
            method:'get',
            url:'https://placementportalwebservices.herokuapp.com/api/user/getAttendance',
            headers : authHeader()
        }).then(res => res.data).catch((e) => {
            if(e.response.status === 403){
                window.location.href  = "/login"
            }
            return Promise.reject(e)
        })
    },
    getTaskDetails : () => {
        return axios({
            method:'get',
            url:'https://placementportalwebservices.herokuapp.com/api/user/getTasks',
            headers : authHeader()
        }).then(res => res.data).catch((e) => {
            if(e.response.status === 403){
                window.location.href  = "/login"
            }
            return Promise.reject(e)
        })
    },
    postNewRequest: (body:any) => {
        return axios.post("https://placementportalwebservices.herokuapp.com/api/user/createRequest",body,{headers : authHeader()}).then(res => {
            return res
        }).catch((e) => {
            if(e.response.status === 403){
                window.location.href  = "/login"
            }
            return Promise.reject(e)
        })
    },
    respondEventRequest: (body:any) => {
        return axios.post("https://placementportalwebservices.herokuapp.com/api/user/updateEvent",body,{headers : authHeader()}).then(res => {
            return res
        }).catch((e) => {
            if(e.response.status === 403){
                window.location.href  = "/login"
            }
            return Promise.reject(e)
        })
    },
    getRequests:() => {
        return axios({
            method:'get',
            url:'https://placementportalwebservices.herokuapp.com/api/user/getRequests',
            headers : authHeader()
        }).then(res => res.data).catch((e) => {
            if(e.response.status === 403){
                window.location.href  = "/login"
            }
            return Promise.reject(e)
        })
    }


}
export default PlacementApi;